"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const subscribe = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-subscribe` : '') + (description ? ` desc-subscribe` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-subscribe"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-subscribe"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.57 1.51A10.48 10.48 0 0 0 2.04 15.3a11 11 0 0 0 1.2 2.49l.14.2-1.42.02H.54l-.11.06a.76.76 0 0 0 .02 1.37l.14.06H5.4l.14-.06a.84.84 0 0 0 .4-.43C6 18.9 6 18.84 6 16.5c0-2.28 0-2.4-.05-2.5a.76.76 0 0 0-1.05-.42.91.91 0 0 0-.34.38c-.06.12-.06.12-.07 1.54l-.01 1.43-.16-.26a9.04 9.04 0 0 1 .76-10.4 9.11 9.11 0 0 1 5.66-3.17 8.97 8.97 0 0 1 4.52.51c.29.11.36.13.5.13.3 0 .56-.17.69-.45a.84.84 0 0 0 0-.58c-.13-.28-.3-.4-1.05-.64a10.06 10.06 0 0 0-3.83-.56Zm7 3.01a.75.75 0 0 0-.53.48c-.04.1-.04.23-.04 2.5 0 2.35 0 2.39.05 2.52.1.27.38.47.68.47.28 0 .46-.09.63-.3.14-.2.14-.17.15-1.71V7.05l.1.14a9.2 9.2 0 0 1 1.38 4.82 9.03 9.03 0 0 1-9.87 8.94 9.22 9.22 0 0 1-2.34-.55c-.47-.18-.61-.19-.85-.08a.72.72 0 0 0-.43.68c0 .33.15.55.48.7A10.51 10.51 0 0 0 20.64 6h1.37c1.33 0 1.37 0 1.5-.05a.75.75 0 0 0-.12-1.44c-.21-.03-4.64-.03-4.81.01Z",
    fill: "black"
  }));
};
var _default = exports.default = subscribe;